import { memo } from "react";
import { classNames } from "shared/lib/classNames/classNames";
import cls from "./SociometryNavigation.module.scss";

interface SociometryNavigationProps {
    onBack: () => void;
    onNext: () => void;
    isBackDisabled: boolean;
    isNextDisabled: boolean;
    isLastQuestion: boolean;
    isSubmitting?: boolean;
    className?: string;
}

export const SociometryNavigation = memo((props: SociometryNavigationProps) => {
    const { onBack, onNext, isBackDisabled, isNextDisabled, isLastQuestion, isSubmitting = false, className } = props;

    return (
        <div className={classNames(cls.sociometryNavigation, {}, [className])}>
            <button
                type="button"
                className={classNames(
                    cls.navButton,
                    {
                        [cls.disabled]: isBackDisabled,
                    },
                    [cls.backButton],
                )}
                onClick={onBack}
                disabled={isBackDisabled}
            />

            <button
                type="button"
                className={classNames(
                    cls.navButton,
                    {
                        [cls.disabled]: isNextDisabled || isSubmitting,
                    },
                    [cls.nextButton],
                )}
                onClick={onNext}
                disabled={isNextDisabled || isSubmitting}
            />
        </div>
    );
});

SociometryNavigation.displayName = "SociometryNavigation";
